/*  MUI  */
import { Grid } from '@mui/material';

/*  Shared  */
import {
    DataAPIVisualsPieChart,
    DataAPIVisualsTotal
} from 'application/Shared/Components/DataAPIVisualsCard';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AdminUsersAccountsCards = ({ data }) => {
    const { t } = useTranslation();

    return (
        <>
            <Grid item xs={12} sm={6} data-testid="adminUsersAccountsCountCard">
                <DataAPIVisualsTotal
                    card
                    data={data}
                    title={t('UsersAccountsAndDevices.accountCount')}
                />
            </Grid>
            <Grid item xs={12} sm={6} data-testid="adminUsersAccountsTypeCard">
                <DataAPIVisualsPieChart
                    accessorKey="personal"
                    card
                    data={data}
                    nameMap={{
                        false: t('Common.work'),
                        true: t('Common.personal')
                    }}
                    title={t('UsersAccountsAndDevices.accountsType')}
                />
            </Grid>
        </>
    );
};
